/* eslint-disable */
import React from 'react';
// import ProgramTable from "../../components";
import ProgramTable from '../../components/pageComponents/dashboard/coach/ProgramTable';
import { useMyPrograms } from '../../hooks/useCourse';
import { useCourseEnrollment } from '../../hooks/useCourseEnrollment';
import {
	EyeIcon,
	LearnersIcon,
} from '../../components/common/Icons';
import ResourceModal, {
	ResourceFile,
} from '../pageComponents/dashboard/coach/ResourceModal';
import { useUploadResource } from '../../hooks/useResource';
import { useNavigate } from 'react-router-dom';
import { useUserProfile } from '../../hooks/useUserProfile';
import { UserProfileCard } from '../../components/pageComponents/managerUsers/UserProfileCard';
import profileDefault from '../../assets/profile/profile.svg';
import styles from './CoachProgramsSection.module.css';
import GenericTable from '../pageComponents/dashboard/coach/GenericTable';
import ProgramCard from '../../components/pageComponents/dashboard/coach/ProgramCard';
import EmptyState from '../../components/common/EmptyState';
import SuccessContent from '../controlVariations/ModularSuccessModal';
import { useCoachProfilePrograms } from '../../hooks/useCourse';
import uploadIcon from '../../assets/profile/Upload.png';
import Tooltip from '../common/ToolTip';

export const UploadIcon = () => (
    <Tooltip text="Add Resource">
        <img
            src={uploadIcon}
            alt="Upload"
            width="40"
            height="40"
        />
    </Tooltip>
);

interface Program {
	id: number;
	name: string;
	learners: number;
	resources: number;
	masterclasses: string;
	sessions: string;
	completionRate: number;
}
interface Props {
	coachId: string;
}

const CoachProgramsSection: React.FC<Props> = ({ coachId }) => {
	// const { courses: myPrograms, isLoading, error } = useMyPrograms(1);
	const { programs, summary, isLoading, error,refresh } =
		useCoachProfilePrograms(coachId);
	const { getCourseEnrollments } = useCourseEnrollment();

	const [enrollmentCounts, setEnrollmentCounts] = React.useState<
		Record<string, number>
	>({});

	const [isLearnersModalOpen, setIsLearnersModalOpen] = React.useState(false);
	const [learnersData, setLearnersData] = React.useState<any[]>([]);

	const { uploadResource } = useUploadResource();
	const [showSuccessPopup, setShowSuccessPopup] = React.useState(false);
	const [isResourceModalOpen, setIsResourceModalOpen] = React.useState(false);
	const [selectedCourseId, setSelectedCourseId] = React.useState<
		string | null
	>(null);
	const [stagedFiles, setStagedFiles] = React.useState<ResourceFile[]>([]);

	const { fetchUserProfileById } = useUserProfile();

	const [selectedUser, setSelectedUser] = React.useState<any>(null);
	const [userData, setUserData] = React.useState<any>(null);
	const [isProfileOpen, setIsProfileOpen] = React.useState(false);

	const fileInputRef = React.useRef<HTMLInputElement | null>(null);

	React.useEffect(() => {
		const fetchCounts = async () => {
			// if (!myPrograms?.length) return;
			if (!programs?.length) return;

			const results = await Promise.all(
				programs.map(program =>
					getCourseEnrollments(program.id)
						.then(res => ({
							id: program.id,
							count: res?.success ? res.data.length : 0,
						}))
						.catch(() => ({
							id: program.id,
							count: 0,
						}))
				)
			);

			const counts: Record<string, number> = {};
			results.forEach(r => {
				counts[r.id] = r.count;
			});

			setEnrollmentCounts(counts);
		};

		fetchCounts();
	}, [programs]);

	const data = (programs || []).map((program: any) => {
		const totalSessions = program.totalsessions || 0;

		// calculate completed sessions from modules
		const completedSessions =
			program.modules?.reduce(
				(acc: number, m: any) => acc + (m.completedlessons || 0),
				0
			) || 0;

		// const completionRate =program.completionrate || 0;
		

const completionRate =
	totalSessions > 0
		? Math.round((completedSessions / totalSessions) * 100)
		: 0;
			

		return {
    ...program,
    learners: program.totalenrolled || 0,
    resources: program.totalresources || 0,

    masterclasses:  0,

    totalSessions,
    completedSessions,

    sessions: `${completedSessions}/${totalSessions}`,

    completionRate,
};
	});
	const ActionButtons = ({ item }: any) => (
		<div className={styles.actions}>
			<button onClick={() => handleViewProgram(item.id)}>
				<EyeIcon />
			</button>

			<button onClick={() => handleViewLearners(item.id)}>
				<LearnersIcon />
			</button>

			<button onClick={() => handleUploadResource(item.id)}>
			   <UploadIcon />
			</button>
		</div>
	);

	const columns = [
		{
			header: 'Program Name',
			key: 'title' as const,
		},
		{
			header: 'Learners',
			key: 'learners' as any,
			render: (item: any) => (
				<span>{enrollmentCounts[item.id] ?? 0}</span>
			),
		},
		{
			header: 'Resources',
			key: 'resources' as any,
			// render: () => <span>0</span>,
			render: (item: any) => <span>{item.totalresources}</span>,
		},
	{
    header: 'Masterclasses',
    key: 'masterclasses' as any,
    render: (item: any) => item.masterclasses,
},
		{
    header: 'Sessions',
    key: 'sessions' as any,
    render: (item: any) => item.sessions,
},
		{
			header: 'Completion Rate',
			key: 'progress' as any,
			render: (item: any) => {
				
				const rate = item.completionRate || 0;
				return (
					<div className={styles.progressWrapper}>
						<div className={styles.progressBar}>
							<div
								className={styles.progressFill}
								style={{ width: `${rate}%` }}
							/>
						</div>
						
					</div>
				);
			},
		},
		{
			header: 'Quick Actions',
			key: 'actions' as any,
			render: (item: any) => <ActionButtons item={item} />,
		},
	];

	const navigate = useNavigate();

	const handleViewProgram = (id: string) => {
		navigate(`/dashboard/programs/${id}`);
	};

	const handleViewLearners = async (courseId: string) => {
		try {
			const response = await getCourseEnrollments(courseId);

			if (response?.success && response.data) {
				const formatted = response.data.map((item: any) => ({
					id: item.userid,
					enrollmentId: item.id,
					name: item.username,
					program: item.coursetitle,
					credentials: item.usermetadata?.credentials || 'N/A',
					role: 'Learner',
				}));

				setLearnersData(formatted);
				setIsLearnersModalOpen(true);
			}
		} catch (err) {
			console.error('Error fetching learners:', err);
		}
	};

	const handleUploadResource = (id: string) => {
		setSelectedCourseId(id);
		setIsResourceModalOpen(true);
	};

	const handleAddFileClick = () => {
		fileInputRef.current?.click();
	};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const files = e.target.files;
		if (!files || files.length === 0) return;

		const file = files[0];

		const newFile: ResourceFile = {
			id: crypto.randomUUID(),
			name: file.name,
			file,
			visibility: true,
			downloadable: true,
		};

		setStagedFiles(prev => [...prev, newFile]);
		e.target.value = '';
	};

	const handleDeleteFile = (id: string) => {
		setStagedFiles(prev => prev.filter(f => f.id !== id));
	};

	const handleToggleVisibility = (id: string) => {
		setStagedFiles(prev =>
			prev.map(f =>
				f.id === id ? { ...f, visibility: !f.visibility } : f
			)
		);
	};

	const handleToggleDownloadable = (id: string) => {
		setStagedFiles(prev =>
			prev.map(f =>
				f.id === id ? { ...f, downloadable: !f.downloadable } : f
			)
		);
	};
	const handleResourceSubmit = async () => {
		if (!selectedCourseId || stagedFiles.length === 0) {
			// alert("Please select file");
			return;
		}

		try {
			for (const staged of stagedFiles) {
				const payload = {
					title: staged.name,
					resourcetype: 'document',
					relatedcourseid: selectedCourseId,
					visibility: staged.visibility ? 'public' : 'private',
					candownload: staged.downloadable,
				};

				await uploadResource(staged.file, payload as any);
			}
			await refresh();

			// alert("Uploaded successfully");
			setStagedFiles([]);
			setIsResourceModalOpen(false);
			setShowSuccessPopup(true);

			// auto close after 3 sec
			setTimeout(() => {
				setShowSuccessPopup(false);
			}, 3000);
		} catch (err) {
			console.error(err);
			// alert("Upload failed");
		}
	};

	const handleViewUser = async (row: any) => {
		try {
			setSelectedUser(row);

			const apiResponse = await fetchUserProfileById(row.id);

			if (apiResponse) {
				const roleName = apiResponse.rolename?.toLowerCase();

				let displayRole = '';

				if (roleName === 'coachee') {
					displayRole = 'Learner';
				} else if (roleName) {
					displayRole =
						roleName.charAt(0).toUpperCase() + roleName.slice(1);
				} else {
					displayRole = 'N/A'; // fallback
				}
				setUserData({
					name: apiResponse.fullname,
					email: apiResponse.email,
					enrolledProgram: row.program,
					phone: apiResponse.phonenumber,
					timezone: apiResponse.preferences?.timezone,
					location: apiResponse.location,
					avatarUrl: apiResponse.profilepicture || profileDefault,
					country: apiResponse.location?.split(',')[1]?.trim() || '',
					platformRole: displayRole,
					organization: apiResponse.organizationname,
					professionalRole: apiResponse.designation,
					areasOfInterest: apiResponse.areasofinterest || [],
					coachingExperience: apiResponse.coachingexperience || [],
					growthWithIOCM: apiResponse.growthparameters || [],
				});

				setIsProfileOpen(true);
			}
		} catch (error) {
			console.error('Error fetching profile:', error);
		}
	};
	return (
		<>
			<div className={styles.container}>
				
				{/* DESKTOP TABLE */}
				<div className={styles.desktopOnly}>
					<ProgramTable
						title="Recent Programs"
						data={data}
						columns={columns}
						itemsPerPage={5}
					/>
				</div>

				{/* MOBILE CARDS */}
				<div className={styles.mobileOnly}>
					<h3 className={styles.mobileSectionTitle}>
						Recent Programs
					</h3>

					<div className={styles.cardList}>
						{data.map((program: any) => {
							const total =
								program.metadata?.dashboard?.totalsessions || 0;
							const done =
								program.metadata?.dashboard
									?.completedsessions || 0;
							const rate =
								total > 0
									? Math.round((done / total) * 100)
									: 0;

							return (
								
								<ProgramCard
									key={program.id}
									programName={program.title}
									completionValue={program.completionRate}
									viewIcon={<EyeIcon />}
									userIcon={<LearnersIcon />}
									onViewClick={() =>
										handleViewProgram(program.id)
									}
									onUserClick={() =>
										handleViewLearners(program.id)
									}
									stats={[
										{
											label: 'Learners',
											value:
												enrollmentCounts[program.id] ??
												0,
										},
										{
											label: 'Resources',
											value: program.resources,
										},
										{
											label: 'Masterclasses',
											value: program.masterclasses,
										},
										{
											label: 'Sessions',
											value: program.sessions,
										}, // ✅ SAME
									]}
								/>
							);
						})}
					</div>
				</div>
			</div>
			{isLearnersModalOpen && (
				<GenericTable
					title="View Learner"
					columns={[
						{ key: 'name', label: 'Full Name' },
						{ key: 'program', label: 'Enrolled Program' },
						{ key: 'credentials', label: 'ICC Credentials' },
						{ key: 'role', label: 'Role' },
						{ key: 'actions', label: 'Quick Actions' },
					]}
					data={learnersData}
					onClose={() => setIsLearnersModalOpen(false)}
					onView={handleViewUser}
				/>
			)}

			<input
				type="file"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={handleFileChange}
			/>
			{isResourceModalOpen && (
				<ResourceModal
					files={stagedFiles}
					onClose={() => setIsResourceModalOpen(false)}
					onAddFile={handleAddFileClick}
					onDeleteFile={handleDeleteFile}
					onToggleVisibility={handleToggleVisibility}
					onToggleDownloadable={handleToggleDownloadable}
					onSubmit={handleResourceSubmit}
				/>
			)}

			{isProfileOpen && userData && (
				<div className={styles.modalOverlay}>
					<div className={styles.modalContent}>
						<UserProfileCard
							mode="view"
							title="View User Profile"
							data={userData}
							showClose
							onClose={() => setIsProfileOpen(false)}
							showEdit={false}
							showDelete={false}
						/>
					</div>
				</div>
			)}
			{showSuccessPopup && (
				<SuccessContent
					title="Resource Uploaded Successfully"
					subtitle="Your file has been uploaded."
				/>
			)}
		</>
	);
};

export default CoachProgramsSection;
